var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2H15H9H7ZM8 4H7C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V7C20 5.34315 18.6569 4 17 4H16V11C16 11.3688 15.797 11.7077 15.4719 11.8817C15.1467 12.0557 14.7522 12.0366 14.4453 11.8321L12 10.2019L9.5547 11.8321C9.24784 12.0366 8.8533 12.0557 8.52814 11.8817C8.20298 11.7077 8 11.3688 8 11V4ZM14 4H10V9.13148L11.4453 8.16795C11.7812 7.94402 12.2188 7.94402 12.5547 8.16795L14 9.13148V4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsBlack);
export default __webpack_public_path__ + "static/media/productsBlack.79682f6c0cdff2a9ae77378eebd74eb8.svg";
export { ForwardRef as ReactComponent };